import { graphql } from 'react-apollo';

import gql from 'graphql-tag';

export default graphql(
  gql`
    mutation ($helperId: String) {
      maybeAddHelpers(action: "maybePromoteCandidateToHelper", helperId: $helperId, input: {})
        @rest(type: "ForumHelperV1", path: "forumHelpers.v1/?{args}", method: "POST") {
        NoResponse
      }
    }
  `,
  {
    name: 'maybeAddHelpers',
  }
);
